import CryptoJS from "crypto-js";
import moment from "moment";
import { io } from "socket.io-client";
const PASSWORD_HASH = process.env.REACT_APP_CRYPTO_PASSWORD_HASH;
const PASSWORD_DECRYPT = process.env.REACT_APP_CRYPTO_PASSWORD_DECRYPT;
const EINVOICE_PASSWORD_HASH = process.env.REACT_APP_EINVOICE_PASSWORD_HASH;
const crypto = require("lkj-cryptography-js");



export const isPanValid = (panNo: string) => {
  if (panNo.length === 10) {
    let panRegex = new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);
    if (panRegex.test(panNo)) return true;
  }
  return false;
};

export const isGstValid = (gstNo: string) => {
  if (gstNo?.length === 15) {
    let gstRegex = new RegExp(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[A-Z0-9]{1}[0-9A-Z]{1}$/
    );
    if (gstRegex.test(gstNo)) return true;
    //previous regex
    // /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
  }
  return false;
};

export const isTanValid = (tanNo: string) => {
  if (tanNo.length === 10) {
    let tanRegex = new RegExp(/^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/);
    if (tanRegex.test(tanNo)) return true;
  }
  return false;
};

export const isIFSCValid = (code: any) => {
  const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  return regex.test(code);
};

export const returnInputFieldLength = (val = 0, limit: undefined | number) => {
  if (typeof limit === "undefined") {
    throw new Error("Limit argument is required!");
  }
  try {
    const count = limit - val;
    return `${count}/${limit} Character Remaining`;
  } catch (err) {
    return err;
  }
};

export const formatDate = (value: string) => {
  return moment(value).format("DD-MM-YYYY");
};

export const formatDateInYear = (value: string) => {
  return moment(value).format("YYYY-MM-DD");
};
export const reverseDate = (value: string) => {
  return value.split("-").reverse().join("-");
};

export const formateDateWithTime = (value: string) => {
  return moment.utc(value).local().format("DD-MM-YYYY, h:mm A");
};

export const formatDateAndTimeWithoutLocal = (value: string) => {
  return moment(value).utc().format("DD-MM-YYYY, h:mm A");
};

export const formateDateTime = (value: string) => {
  return moment(value).local().format("DD-MM-YYYY, h:mm A");
};
export const formateDateAndTime = (value: string) => {
  const date = new Date(value);
  return date.toISOString().replace("T", " ").split(".")[0];
};

export const formateLocalDateAndTime = (value: string) => {
  const date = new Date(value);
  return moment.utc(value).format("DD-MM-YYYY, h:mm A");
};

export const testJSON = (text: any) => {
  if (typeof text !== "string") {
    return false;
  }
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
};

export const currencySignAndNegativeValueAdjust = (
  currency: string | undefined,
  amount: string
) => {
  const splitMinusSign: any = amount?.split("-");
  if (splitMinusSign?.length === 2) {
    return `-${currency}${splitMinusSign[1]}`;
  } else {
    return `${currency}${amount}`;
  }
};

export const reverseDateFormat = (value: string) => {
  return value ? value.split("-").reverse().join("-") : "";
};

export const isEmailValid = (email: string | undefined): boolean => {
  if (email) {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"#$&*$!%^]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(String(email).toLowerCase());
  }
  return false;
};
export const isStcoEmailValid = (email: string | undefined): boolean => {
  if (email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@(stco\.co\.in|akssai\.com)$/i;
    return emailRegex.test(String(email).toLowerCase());
  }
  return false;
};

//previous code
// /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
// export const isEmailValid = (email: string | undefined): boolean => {
//   if (email) {
//     const emailRegex =
//       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     return emailRegex.test(String(email).toLowerCase());
//   }

//   return false;
// };

// number With Commas
export const numberWithCommas = (data: any) => {
  return new Intl.NumberFormat("en-IN", { maximumSignificantDigits: 3 }).format(
    data
  );
};

//first letter capital
export const capitalize = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

/*
  Regex for password:
    - Should have be more than 8 characters,
    - Include at least one capital letter,
    - At least one special character, and
    - At least one number
*/
export const isPasswordValid = (password: string | undefined): boolean => {
  if (password) {
    const passwordRegex = /^(?=.*[a-z])(?=.*\d).{8,}$/g;
    return passwordRegex.test(String(password));
  }
  return false;
};

export const checkHasNumber = (password: string | undefined): boolean => {
  if (password) {
    const passwordRegex = /.*\d.*/g;
    return passwordRegex.test(String(password));
  }

  return false;
};

export const checkHasSpecial = (password: string | undefined): boolean => {
  if (password) {
    const passwordRegex = /[*@!#%&$()^~{}]+/g;
    return passwordRegex.test(String(password));
  }

  return false;
};

export const checkHasUpperLetter = (password: string | undefined): boolean => {
  if (password) {
    const passwordRegex = /.*[A-Z].*/g;
    return passwordRegex.test(String(password));
  }

  return false;
};

export const checkHasLowerLetter = (password: string | undefined): boolean => {
  if (password) {
    const passwordRegex = /.*[a-z].*/g;
    return passwordRegex.test(String(password));
  }

  return false;
};

export const convertPasswordToHash = async (data: any) => {
  const key = PASSWORD_HASH ? CryptoJS.enc.Utf8.parse(PASSWORD_HASH) : undefined;
  const iv = PASSWORD_DECRYPT ? CryptoJS.enc.Utf8.parse(PASSWORD_DECRYPT) : undefined;


  if (!key || !iv) {
    throw new Error("Missing encryption key or IV.");
  }

  const encrypted = CryptoJS.AES.encrypt(data, key, { iv });
  return encrypted.toString();
}

export const convertEinvoicePasswordToHash = async (password: string) => {
  let AES_Crypto = crypto.AES_Crypto;
  let encrypted_data = await AES_Crypto.encryptData(
    EINVOICE_PASSWORD_HASH,
    "aes-128-cbc",
    password
  );

  return encrypted_data;
};

// DO NOT DELETE
/* export const decryptUserToken = async (userToken: string) => {
  let AES_Crypto = crypto.AES_Crypto;

  let userData = await AES_Crypto.decryptData(
    PASSWORD_DECRYPT,
    "aes-128-cbc",
    userToken
  );

  let user_data = JSON.parse(userData)
  return user_data;
}; */

export const setCookie = (key: any, value?: any, remove?: any) => {
  if (value) {
    let expiry = new Date(Number(new Date()) + 30 * 24 * 3600000).toString();
    document.cookie = key + "=" + value + ";path=/;expires=" + expiry + ";";
    return;
  }
  let all = document.cookie.split(";");
  let temp = null;
  for (let i in all) {
    let keyAndValue = all[i].split("=");
    if (keyAndValue[0].trim() === key.trim()) {
      temp = keyAndValue[1];
      break;
    }
  }
  if (remove) {
    document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  }
  return temp;
};

export const handleDate = (value: any) => {
  if (value === "Invalid date") {
    return "";
  } else {
    return value;
  }
};
export const calculateDate = () => {
  let curr = new Date();
  let day = +curr.getDate();
  let month = +curr.getMonth() + 1;
  let year = +curr.getFullYear();
  if (day === 1) {
    if (month === 4 || month === 6 || month === 9 || month === 11) {
      day = 30;
      month--;
    } else if (month === 3) {
      if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
        day = 29;
        month--;
      } else {
        day = 28;
        month--;
      }
    } else {
      if (month === 12) {
        day = 31;
        month = 12;
        year--;
      }
      day = 30;
      month--;
    }
  } else {
    day--;
  }
  if (+day < 10 && month < 10) {
    return `0${day}-0${month}-${year}, 11:59:00 PM`;
  } else if (+day < 10) {
    return `0${day}-${month}-${year}, 11:59:00 PM`;
  } else if (+month < 10) {
    return `${day}-0${month}-${year}, 11:59:00 PM`;
  }
  return `${day}-${month}-${year}, 11:59:00 PM`;
};

export function getCurrentFinancialYear() {
  var fiscalyear = "";
  var today = new Date();
  if (today.getMonth() + 1 > 3 && today.getMonth() + 1 <= 12) {
    fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1);
  } else {
    fiscalyear = today.getFullYear() - 1 + "-" + today.getFullYear();
  }
  return fiscalyear;
}

export function previousFinancialYear() {
  var fiscalyear = "";
  var today = new Date();
  if (today.getMonth() + 1 > 3 && today.getMonth() + 1 <= 12) {
    fiscalyear = today.getFullYear() - 1 + "-" + today.getFullYear();
  } else {
    fiscalyear = today.getFullYear() - 2 + "-" + (today.getFullYear() - 1);
  }

  return fiscalyear;
}

export function getLastFiveFinancialYears() {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const financialYears = [];

  // Assuming financial year starts in April
  const financialYearStartMonth = 3; // 3 is April

  // Determine the starting year of the current financial year
  let startYear;
  if (currentMonth >= financialYearStartMonth) {
    startYear = currentYear;
  } else {
    startYear = currentYear - 1;
  }

  for (let i = 0; i < 5; i++) {
    const endYear = startYear + 1;
    const financialYear = `${startYear}-${endYear}`;
    financialYears.push({ label: financialYear, value: financialYear });
    startYear -= 1;
  }

  return financialYears;
}

export const twoDigitAfterDecimel = (num: number) => {
  let fixingDecimel = num.toFixed(2);
  return +fixingDecimel;
};

export function checkSameEmail(email: string, arr: any) {
  let temp = false;
  for (let i = 0; i < arr?.length; i++) {
    if (arr[i]?.email === email) {
      temp = true;
      break;
    }
  }
  return temp;
}

export function checkSameUserId(id: number, arr: any) {
  let temp = false;
  for (let i = 0; i < arr?.length; i++) {
    if (arr[i]?.user_id === id) {
      temp = true;
      break;
    }
  }
  return temp;
}

export var monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export function currentMonth() {
  let date = new Date();
  var month = monthNames[date.getMonth()];
  return month;
}

export function currentYear() {
  return new Date().getFullYear();
}

export function currentDate() {
  let currentDate = new Date().toJSON().slice(0, 10);
  return currentDate;
}

export function convertMsToHourMinSec(diff: any = 0) {
  let msec = diff;

  if (msec > 0) {
    let hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    let mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    let ss = Math.floor(msec / 1000);
    msec -= ss * 1000;

    return `${hh < 10 ? `0${hh}` : hh}:${mm < 10 ? `0${mm}` : mm}:${ss < 10 ? `0${ss}` : ss
      }`;
  } else {
    return `00:00:00`;
  }
}

export const checkFormatDdMmYyyy = (text: string) => {
  if (text) {
    let checkFormat = new RegExp(
      "^(0[1-9]|[1-9]|[12][0-9]|3[01])-(0[1-9]|[1-9]|1[012])-(19|20)\\d\\d$"
    );

    let bool = checkFormat.test(String(text));

    return bool;
  }
  return false;
};

export function calculatePreviousDate(date: string, day: number) {
  const reverse_date = new Date(date);
  const one_day_less_date = new Date(reverse_date);
  one_day_less_date.setDate(reverse_date.getDate() - day);
  const res = one_day_less_date.toISOString().split("T")[0];
  return res.split("-").join("-");
}

export function previousTwoFinancialYear() {
  var fiscalyear = "";
  var today = new Date();
  if (today.getMonth() + 1 > 3 && today.getMonth() + 1 <= 12) {
    fiscalyear = today.getFullYear() - 2 + "-" + (today.getFullYear() - 1);
  } else {
    fiscalyear = today.getFullYear() - 3 + "-" + (today.getFullYear() - 2);
  }

  return fiscalyear;
}

export const validKeyPattern = (str: string | undefined): boolean => {
  if (str) {
    const strRegex = /^[A-Za-z0-9 !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\t\n\r]+$/;
    return strRegex.test(String(str));
  }

  return false;
};

export function daysBetween(startDate: string, endDate: string) {
  const start: any = new Date(startDate);
  const end: any = new Date(endDate);
  const diffInMilliseconds = end - start;
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
  return Math.abs(diffInDays) + 1;
}

export const getCurrentMonthDates = () => {
  const date = new Date();
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return {
    start: moment(firstDay).format("YYYY-MM-DD"),
    end: moment(lastDay).format("YYYY-MM-DD"),
  };
};

export const withoutValueButtons = [
  112, // F1
  113, // F2
  114, // F3
  115, // F4
  116, // F5
  117, // F6
  118, // F7
  119, // F8
  120, // F9
  121, // F10
  122, // F11
  123, // F12
  9, // Tab
  13, // Enter
  16, // Shift
  17, // Control
  18, // Alt
  19, // Pause/Break
  20, // Caps Lock
  27, // Escape
  32, // Space
  33, // Page Up
  34, // Page Down
  35, // End
  36, // Home
  37, // Left Arrow
  38, // Up Arrow
  39, // Right Arrow
  40, // Down Arrow
  45, // Insert
  46, // Delete
  91, // Left Windows key
  92, // Right Windows key
  93, // Right-click key (on some keyboards)
  144, // Num Lock
  145, // Scroll Lock
];

export function price_in_words(value: any, currencyShortForm: string) {
  var fraction = Math.round(frac(value) * 100);
  var decimal = value % 1 === 0 ? 0 : 1;
  var f_text = "";

  if (decimal > 0) {
    f_text = " AND " + convert_number(fraction);
  }

  return (
    convert_number(value) +
    ` ${currencyShortForm === "USD"
      ? "DOLLAR"
      : currencyShortForm === "CAD"
        ? "DOLLAR"
        : currencyShortForm === "TWD"
          ? "DOLLAR"
          : currencyShortForm === "EUR"
            ? "EURO"
            : currencyShortForm === "GBP"
              ? "POUND"
              : currencyShortForm === "INR"
                ? "RUPEE"
                : currencyShortForm === "CNY"
                  ? "YUAN"
                  : ""
    }` +
    f_text +
    `${f_text && currencyShortForm === "USD"
      ? " CENT"
      : f_text && currencyShortForm === "CAD"
        ? " CENT"
        : f_text && currencyShortForm === "TWD"
          ? " CENT"
          : f_text && currencyShortForm === "EUR"
            ? " CENT"
            : f_text && currencyShortForm === "GBP"
              ? " PENNY"
              : f_text && currencyShortForm === "INR"
                ? " PAISE"
                : f_text && currencyShortForm === "CNY"
                  ? " FEN"
                  : ""
    } ONLY`
  );
}

function frac(f: number) {
  return f % 1;
}

function convert_number(number: number) {
  if (number < 0 || number > 999999999) {
    return "NUMBER OUT OF RANGE!";
  }
  var Gn = Math.floor(number / 10000000); /* Crore */
  number -= Gn * 10000000;
  var kn = Math.floor(number / 100000); /* lakhs */
  number -= kn * 100000;
  var Hn = Math.floor(number / 1000); /* thousand */
  number -= Hn * 1000;
  var Dn = Math.floor(number / 100); /* Tens (deca) */
  number = number % 100; /* Ones */
  var tn = Math.floor(number / 10);
  var one = Math.floor(number % 10);
  var res = "";

  if (Gn > 0) {
    res += convert_number(Gn) + " CRORE";
  }
  if (kn > 0) {
    res += (res == "" ? "" : " ") + convert_number(kn) + " LAKH";
  }
  if (Hn > 0) {
    res += (res == "" ? "" : " ") + convert_number(Hn) + " THOUSAND";
  }

  if (Dn) {
    res += (res == "" ? "" : " ") + convert_number(Dn) + " HUNDRED";
  }

  var ones = Array(
    "",
    "ONE",
    "TWO",
    "THREE",
    "FOUR",
    "FIVE",
    "SIX",
    "SEVEN",
    "EIGHT",
    "NINE",
    "TEN",
    "ELEVEN",
    "TWELVE",
    "THIRTEEN",
    "FOURTEEN",
    "FIFTEEN",
    "SIXTEEN",
    "SEVENTEEN",
    "EIGHTEEN",
    "NINETEEN"
  );
  var tens = Array(
    "",
    "",
    "TWENTY",
    "THIRTY",
    "FOURTY",
    "FIFTY",
    "SIXTY",
    "SEVENTY",
    "EIGHTY",
    "NINETY"
  );

  if (tn > 0 || one > 0) {
    if (!(res == "")) {
      res += " ";
    }
    if (tn < 2) {
      res += ones[tn * 10 + one];
    } else {
      res += tens[tn];
      if (one > 0) {
        res += "-" + ones[one];
      }
    }
  }

  if (res == "") {
    res = "zero";
  }
  return res;
}

export const preventEnterKey = (e: any) => {
  if (e.key === "Enter") {
    e.preventDefault(); // Prevent the default behavior
  }
};

export function current_month_first_date() {
  let date = new Date();
  let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  return moment(firstDay).format("DD-MM-YYYY");
}

export function current_month_last_date() {
  let date = new Date();
  let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return moment(lastDay).format("DD-MM-YYYY");
}

export function changeToDecimel(num: number) {
  if (num?.toString()?.includes(".")) {
    return num?.toFixed(2);
  } else {
    return num;
  }
}

export function isWeekend(date: Date, weekDays?: number) {
  const day = date.getDay();
  if (weekDays && weekDays === 5) {
    return day === 0 || day === 6; // Sunday or Saturday
  } else if (weekDays === 7) {
    return false; //no leave
  } else {
    return day === 0; // Sunday
  }
}

export function getDatesInRange(
  startDate: any,
  endDate: any,
  weekDays?: number,
  holidays?: string[]
) {
  const date = new Date(startDate);

  const dates = [];

  while (date <= endDate) {
    if (
      !isWeekend(date, weekDays) &&
      !isHoliday(date, holidays ? holidays : [])
    ) {
      dates.push(formatDate(new Date(date).toString()));
    }
    date.setDate(date.getDate() + 1);
  }

  return dates;
}

function isHoliday(date: Date, holidays: string[]) {
  const dateString = formatDate(date.toString());
  return holidays.includes(reverseDate(dateString));
}

export function currentMonthNumber() {
  var currentDate = new Date();
  var currentMonth = currentDate.getMonth() + 1;
  return currentMonth;
}

export function daysBetweenDates(startDate: any, endDate: any) {
  const startDateParts = startDate.split("-").map(Number);
  const endDateParts = endDate.split("-").map(Number);

  const startDateObj = new Date(
    startDateParts[2],
    startDateParts[1] - 1,
    startDateParts[0]
  );
  const endDateObj = new Date(
    endDateParts[2],
    endDateParts[1] - 1,
    endDateParts[0]
  );

  const timeDifference = endDateObj.getTime() - startDateObj.getTime();

  const daysDifference = timeDifference / (1000 * 3600 * 24);

  const numberOfDays = Math.floor(daysDifference);

  return numberOfDays;
}

export const monthAbbreviations = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

export function showDateWithMonthAndYear(dateString: any) {
  const [day, month, year] = dateString.split("-");
  const monthAbbreviation = monthAbbreviations[parseInt(month, 10) - 1];
  return `${day} ${monthAbbreviation} ${year}`;
}

export function getStartDateFromEndDate(endDate: any) {
  if (!(endDate instanceof Date)) {
    endDate = new Date(endDate);
  }

  const endYear = endDate.getFullYear();
  const endMonth = endDate.getMonth();
  const startYear = endMonth >= 3 ? endYear : endYear - 1;

  return `${startYear}-04-01`;
}

export function formatTimeWithSpace(date: any) {
  const formattedTime = moment(date, "DD-MM-YYYY HH:mm:ss").format(
    "DD-MM-YYYY hh:mm:ss A"
  );
  return formattedTime;
}

export function getCSRFToken() {
  return localStorage.getItem("csrfToken");
}

export function getDateDifference(startDates: string) {
  var givenDate = new Date(startDates);

  var today = new Date();
  if (givenDate > today) {
    return "Years: 0, Months: 0, Days: 0";
  } else {
    var difference = today.getTime() - givenDate.getTime();

    var daysDifference = Math.floor(difference / (1000 * 60 * 60 * 24));

    var years = Math.floor(daysDifference / 365);
    var months = Math.floor((daysDifference % 365) / 30);
    // var days = (daysDifference % 365) % 30;

    var response = "";
    if (years !== 0) {
      response += years + " Years";
    }
    if (months !== 0) {
      response += (response === "" ? "" : ", ") + months + " Months";
    }
    // if (days !== 0) {
    //     response += (response === "" ? "" : ", ") + days  + " Day's";
    // }
    if (response !== "") {
      response = "Year in Organization " + response;
    }
    return response;
  }
}

export function getTodayDateWithTimeStamp() {
  let currentDate = new Date();
  currentDate.setMinutes(currentDate.getMinutes() + 330);
  return currentDate.toISOString();
}

export function romanize(num: number | undefined) {
  if (!num) return;
  if (isNaN(num)) return NaN;
  var digits: any = String(+num).split(""),
    key = [
      "",
      "C",
      "CC",
      "CCC",
      "CD",
      "D",
      "DC",
      "DCC",
      "DCCC",
      "CM",
      "",
      "X",
      "XX",
      "XXX",
      "XL",
      "L",
      "LX",
      "LXX",
      "LXXX",
      "XC",
      "",
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
    ],
    roman = "",
    i = 3;
  while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;
}

export function getAlphabets(number: number | undefined) {
  if (!number) return;
  let result = [];
  let start = "a".charCodeAt(0); // ASCII code of 'a'
  let end = "z".charCodeAt(0); // ASCII code of 'z'

  // Loop through the range specified by number
  for (let i = 0; i < number; i++) {
    let index = i % 26; // Modulo 26 to wrap around after 'z'
    let charCode = start + index;
    let char = String.fromCharCode(charCode);

    if (i >= 26) {
      // Append a number suffix starting from '1'
      char += Math.floor(i / 26) + 1;
    }

    result.push(char);
  }

  return result[number - 1];
}

export function getFinancialYearDates() {
  const today = new Date();
  const year = today.getFullYear();
  let startDate: any, endDate: any;

  if (today.getMonth() + 1 >= 4) {
    // April is the 4th month
    startDate = new Date(year, 3, 1); // April 1st of the current year
  } else {
    startDate = new Date(year - 1, 3, 1); // April 1st of the previous year
  }

  endDate = new Date(today);
  endDate.setDate(endDate.getDate() - 4); // 4 days before today

  return {
    startDate,
    endDate,
  };
}

export function getMonthNumber(str: string) {
  let monthNumber = 0;

  let strUpper = str?.toUpperCase();
  for (var i = 0; i < monthAbbreviations?.length; i++) {
    if (monthAbbreviations[i] === strUpper) {
      monthNumber = i + 1;
      break;
    }
  }
  return monthNumber;
}

export function convertToISO(dateString: string): string {
  // Input format: MM/DD/YYYY hh:mm:ss AM/PM

  const [datePart, timePart, period] = dateString.split(" ");
  const [day, month, year] = datePart.split("/").map(Number);
  let [hours, minutes, seconds] = timePart.split(":").map(Number);

  // Convert hours based on AM/PM
  if (period === "PM" && hours !== 12) {
    hours += 12;
  } else if (period === "AM" && hours === 12) {
    hours = 0;
  }

  // Create a Date object in local time
  const date = new Date(year, month - 1, day, hours, minutes, seconds);

  // Format to ISO 8601 string in local time zone
  const isoString = date.toISOString();
  return isoString;
}

export const getFullMonthName = (monthData: string) => {
  const monthIndex = monthAbbreviations.indexOf(monthData?.toUpperCase());
  return monthIndex !== -1 ? monthNames[monthIndex] : undefined;
};

export function getLastThreeMonths() {
  const today = new Date();
  const lastThreeMonths = new Date();

  lastThreeMonths.setMonth(today.getMonth() - 3);

  const day = lastThreeMonths.getDate().toString().padStart(2, "0");
  const month = (lastThreeMonths.getMonth() + 1).toString().padStart(2, "0");
  const year = lastThreeMonths.getFullYear();

  return `${day}-${month}-${year}`;
}

export function getLastSixMonths() {
  const today = new Date();
  const lastSixMonths = new Date();

  lastSixMonths.setMonth(today.getMonth() - 6);

  const day = lastSixMonths.getDate().toString().padStart(2, "0");
  const month = (lastSixMonths.getMonth() + 1).toString().padStart(2, "0");
  const year = lastSixMonths.getFullYear();

  return `${day}-${month}-${year}`;
}

// DD-MM-YY 
export const formatToShortDate = (value: string) => {
  const date = new Date(value);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = String(date.getFullYear()).slice(-2); // Get last two digits of year
  return `${day}-${month}-${year}`;
}

// src/utils/socketService.ts


// src/utils/socketService.ts


let socket: any;

export const initializeSocket = (user_id: number) => {
  if (!user_id) {
    console.warn("Socket not initialized: user_id is missing");
    return null;
  }

  const wsServer = process.env.REACT_APP_WEBSOCKET_SERVER;
  const url = `${wsServer}`;

  if (socket && socket.connected) {
    return socket;
  }

  socket = io(url, {
    transports: ["websocket"],
    forceNew: true,
    rejectUnauthorized: false,
    query: {
      user_id: user_id,
    },
  });

  socket.on("connect", () => {
    const engine = socket.io.engine;
    engine.once("upgrade", () => { });
  });

  socket.on("disconnect", () => {
  });

  socket.on("connect_error", (error: any) => {
  });

  return socket;
};

export const emitNotification = (eventName: string, payload: any) => {
  if (!socket) {
    console.warn("Socket is not initialized.");
    return;
  }

  if (socket.connected) {
    socket.emit(eventName, payload);
  } else {
    socket.once("connect", () => {
      socket.emit(eventName, payload);
    });
  }
};
